import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import moment from 'moment'
import 'moment/locale/tr'
import {Button, Card, Col, Form, FormControl, Row, Spinner, Tab, Table, Tabs} from 'react-bootstrap';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import Helmet from 'react-helmet';
import './App.css';
import {InfoTwoTone} from "@mui/icons-material";
import TextField from '@mui/material/TextField';
import WarningTwoToneIcon from '@mui/icons-material/WarningTwoTone';

import {
    adminManagementCheckUrl,
    changeToPresaleFixedUrl,
    connectionErrorMessage,
    couponManagementCheckUrl,
    defaultAhtapotRequestDto,
    defaultRequestDto,
    errorMessage,
    getAhtapotUpdateFileCountDtoUrl,
    getAllMuvekkilTenants,
    getMuvekkilTenantsWithoutSubscription,
    getPaymentHistoryUrl,
    getTenantList,
    helmetTitle,
    maxCount,
    selectTenantId,
    startAhtapotDemoTenantSubscriptionUrl,
    startUgyDemoTenantSubscriptionUrl,
    tenantInfoUrl,
    updateAhtapot,
    updateTenant,
    updateTenantSubscriptionStatusUrl
} from './data.js';
import {useCookies} from 'react-cookie';
import Login from './Login';
import TooltipDialog from "./ui/dialog/TooltipDialog";
import FormDialog from "./ui/dialog/FormDialog";
import DetailListDialog from "./ui/dialog/DetailListDialog";
import EtcDataGrid from "./ui/grid/EtcDataGrid";
import DiscountManagerPanel from "./discount/DiscountManagerPanel";
import Tooltip from '@mui/material/Tooltip';
import {GridRenderCellParams} from "@mui/x-data-grid";
import PaymentModal from "./ui/modal/PaymentModal";
import OnlinePaymentDisabledNotice, {
    ONLINE_PAYMENT_ENABLED,
    disabledPaymentButtonStyle
} from "./ui/OnlinePaymentDisabledNotice";
import AhtapotUpdateFileCountFormDialog from "./ahtapot/AhtapotUpdateFileCountFormDialog";
import {debugLog} from "./debug";
import MembershipModalDialog from "./ui/dialog/MembershipModalDialog";
import ManualPaymentUpdateDialog from "./ui/dialog/ManualPaymentUpdateDialog";


const WARNING_BEFORE_DATE_MSG = "Üyelik Bitiş Tarihi, Günün Tarihinden Geri Olamaz!";
const NOT_VALID_MANUAL_PAYMENT_RECORD = "Bu işlem Sadece Faturalıya Çevrilen Üyelik Kayıtlarında Yapılabilir!";

function SubscriptionAdminPanel({setCookie, removeCookie}) {
    const [cookies] = useCookies(['subscriptionToken']);
    const [actionCount, setActionCount] = useState(0);
    const [requestDto, setRequestDto] = useState(defaultRequestDto);
    const [ahtapotRequestDto, setAhtapotRequestDto] = useState(defaultAhtapotRequestDto);
    const [tenantList, setTenantList] = useState([]);
    const [paymentHistoryData, setPaymentHistoryData] = useState([]);
    const [subscriptionFeatureTypeDtoList, setSubscriptionFeatureTypeDtoList] = useState([]);
    const [selectAllFeatures, setSelectAllFeatures] = useState(false);
    const [selectedSubscriptionFeatureTypeDtoList, setSelectedSubscriptionFeatureTypeDtoList] = useState([]);
    const [featureCount, setFeatureCount] = useState(0);
    const [validIntervalEndDateTime, setValidIntervalEndDateTime] = useState('');
    const [ahtapotValidIntervalEndDateTime, setAhtapotValidIntervalEndDateTime] = useState('');
    const [activeTenantSubscription, setActiveTenantSubscription] = useState('');
    const [activeAhtapotTenantSubscription, setActiveAhtapotenantSubscription] = useState('');
    const [expiryDayCount, setExpiryDayCount] = useState(0);
    const [ahtapotExpiryDayCount, setAhtapotExpiryDayCount] = useState(0);
    const [defaultTenantProperties, setDefaultTenantProperties] = useState({});
    const [tenantSubscriptionViewDto, setTenantSubscriptionViewDto] = useState({});
    const [loginShow, setLoginShow] = useState(false);
    const [tenantDataShow, setTenantDataShow] = useState(null);
    const [tabKey, setTabKey] = useState('payment');
    const [firstTabKey, setFirstTabKey] = useState('tenantTab');
    const [selectionModel, setSelectionModel] = useState([]);
    const [ready, setReady] = useState(false);
    const [showDiscountManagerPanel, setShowDiscountManagerPanel] = useState(false);
    const [toolTipText, setToolTipText] = useState("");
    const [toolTipTitle, setToolTipTitle] = useState("");
    const [openTooltipModal, setOpenTooltipModal] = React.useState(false);
    const [openDetailListDialogModal, setOpenDetailListDialogModal] = React.useState(false);
    const [openStatusFormDialog, setOpenStatusFormDialog] = React.useState(false);
    const [tenantSubscriptionStatusRequestDto, setTenantSubscriptionStatusRequestDto] = React.useState({});
    const [hasCouponManagement, setHasCouponManagement] = React.useState(false);
    const [hasAdminManagement, setHasAdminManagement] = React.useState(false);
    const [isPresaleFixed, setIsPresaleFixed] = React.useState(false);
    const [hasAhtabotSubscription, setHasAhtabotSubscription] = React.useState(false);
    const [isAllTenants, setIsAllTenants] = React.useState(false);
    const [refreshGrid, setRefreshGrid] = React.useState(false);
    const [payAmount, setPayAmount] = useState(0);
    const [showPayModal, setShowPayModal] = useState(false);
    const [ahtapotUpdateFileCountDto, setAhtapotUpdateFileCountDto] = React.useState("");
    const [openUpdateFileCountFormDialog, setOpenUpdateFileCountFormDialog] = React.useState(false);
    const [isMuvekkilTenants, setIsMuvekkilTenants] = React.useState(false);
    const [isMuvekkilTenantsWithoutSubscription, setIsMuvekkilTenantsWithoutSubscription] = React.useState(false);
    const [ahtapotSubscriptionInformationText,setAhtapotSubscriptionInformationText]= React.useState("");
    const [isMembershipModalDialogOpen, setIsMembershipModalDialogOpen] = useState(false);
    const [isManualPaymentUpdateDialogOpen, setIsManualPaymentUpdateDialogOpen] = useState(false);
    const [selectedTenant, setSelectedTenant] = useState(null);

    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedRows, setSelectedRows] = useState(null);
    const [selectedPaymentAmount, setSelectedPaymentAmount] = useState("0");

    const manualPaymentText = "Banka hesabına transfer ile yapılan ödeme kaydı.";

    const handleSelectionChange = (newSelection) => {
        const newSelectionModel = newSelection;
        if (newSelectionModel.length > 1) {
            const selectionSet = new Set(selectedIds);
            const result = newSelectionModel.filter(
                (s) => !selectionSet.has(s)
            );
            setSelectedIds(result);
            const selectedData = paymentHistoryData.filter(row => row.id === result[0]);
            setSelectedRows(selectedData[0]);
            setSelectedPaymentAmount(formatToTRCurrency(selectedData[0]?.paymentAmount));

        } else {
            setSelectedIds(newSelectionModel);
            const selectedData = paymentHistoryData.filter(row => row.id === newSelectionModel[0]);
            setSelectedRows(selectedData[0]);
            setSelectedPaymentAmount(formatToTRCurrency(selectedData[0]?.paymentAmount));
        }
    };

    const formatToTRCurrency = (value) => {
        if (value == null) return "0";
        let numericValue = parseFloat(value);

        return numericValue.toLocaleString('tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const handleOpenMembershipModalDialog = () => {
        setIsMembershipModalDialogOpen(true);
    };

    const handleOpenManualPaymentUpdateDialog = () => {
        if (!selectedRows) {
            toast.error("Lütfen kayıt seçiniz.", {
                position: toast.POSITION.TOP_CENTER
            });
        } else if (!selectedTenant?.hasAhtapotSubscription) {
            toast.error("Pasif üyeliklerde işlem yapılamaz.", {
                position: toast.POSITION.TOP_CENTER
            });
        } else if (selectedTenant?.hasAhtapotSubscription && selectedRows?.paymentRemark && selectedRows?.paymentRemark.includes(manualPaymentText)) {
            setIsManualPaymentUpdateDialogOpen(true);
        } else {
            toast.error(NOT_VALID_MANUAL_PAYMENT_RECORD, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    };

    const currencyFormatter = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
    });


    const closeShowPayModal = () => {
        setShowPayModal(false);
    }

    const openPayModal = () => {
        setShowPayModal(true);
    }

    const startAhtapotDemo = () => {
        if (!tenantSubscriptionViewDto) {
            toast.error("Geçersiz Kullanıcı", {
                position: toast.POSITION.TOP_CENTER
            });
        }

        fetch(startAhtapotDemoTenantSubscriptionUrl,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
                },
                body: JSON.stringify(tenantSubscriptionViewDto)
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                onSelectionModelChange(selectionModel);
            }, (error) => {
                if (error) {
                    toast.error("Geçersiz Kullanıcı", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    const startUgyDemo=()=>{
        if (!tenantSubscriptionViewDto) {
            toast.error("Geçersiz Kullanıcı", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        fetch(startUgyDemoTenantSubscriptionUrl,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
                },
                body: JSON.stringify(tenantSubscriptionViewDto)
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                onSelectionModelChange(selectionModel);
            }, (error) => {
                if (error) {
                    toast.error("Hata Oluştu", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    };

    const handleOpenTooltipModal = (item) => {
        if (item && item.tooltip) {
            setToolTipTitle(item.name);
            setToolTipText(item.tooltip);
            setOpenTooltipModal(true);
        }
    };

    const handleCloseTooltipModal = () => {
        setOpenTooltipModal(false);
    };

    const handleCloseDetailListDialogModal = () => {
        setOpenDetailListDialogModal(false);
    };

    const handleOpenStatusFormDialog = () => {
        setOpenStatusFormDialog(true);
    };

    const handleCloseStatusFormDialog = () => {
        setOpenStatusFormDialog(false);
    };

    const handleAcceptStatusFormDialog = (reason) => {
        tenantSubscriptionStatusRequestDto.reason = reason;
        fetch(updateTenantSubscriptionStatusUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify(tenantSubscriptionStatusRequestDto)
        }).then(res => {
            if (res.ok) {
                toast.success("Abonelik " + (tenantSubscriptionStatusRequestDto.status === "active" ? "aktif" : "pasif") + " edildi.", {
                    position: toast.POSITION.TOP_CENTER
                });
                getDataTenantList();
                changeTenantId(selectionModel);
            } else {
                throw new Error(connectionErrorMessage);
            }
        })

        setOpenStatusFormDialog(false);
    };

    void hasAhtabotSubscription;

    useEffect(() => {
        if (!cookies.subscriptionToken) {
            toast.error(connectionErrorMessage, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        fetch(tenantInfoUrl,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
                },
                body: JSON.stringify({})
            })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                let selectedSubscriptionFeatureTypeRequestDtoList = [];
                if (data.subscriptionFeatureTypeResponseDtoList) {
                    data.subscriptionFeatureTypeResponseDtoList.map(function (item) {
                        if (item.selected) {
                            selectedSubscriptionFeatureTypeRequestDtoList.push(item);
                        }
                        return item;
                    });
                }

                setRequestDto(
                    {
                        activeDosyaCount: data.activeDosyaCount,
                        openUyapDosyaCount: data.openUyapDosyaCount,
                        tokenCount: data.tokenCount,
                        userCount: data.userCount,
                        ownerTenantId: data.ownerTenantId,
                        validIntervalEndDateTime: data.validIntervalEndDateTime,
                        subscriptionFeatureTypeRequestDtoList: selectedSubscriptionFeatureTypeRequestDtoList

                    }
                );

                setAhtapotRequestDto(
                    {
                        ownerTenantId: data.ownerTenantId,
                        ahtapotValidIntervalEndDateTime: data?.ahtapotSubscriptionViewDto?.ahtapotValidIntervalEndDateTime,
                        ahtapotFileCount: data.ahtapotSubscriptionViewDto?.ahtapotFileCount,
                        activeDosyaCountAhtapot: data.ahtapotSubscriptionViewDto?.activeDosyaCountAhtapot
                    }
                );

                setSelectedSubscriptionFeatureTypeDtoList(selectedSubscriptionFeatureTypeRequestDtoList);
                setTenantSubscriptionViewDto(data);

                if (data.selectedSubscriptionBillingTypeEnumValue !== "PRESALE_DEMO") {
                    setDefaultTenantProperties({
                        defaultUyapDosyaCount: data.openUyapDosyaCount,
                        defaultTokenCount: data.tokenCount,
                        defaultUserCount: data.userCount
                    });

                    if (data.subscriptionFeatureTypeResponseDtoList) {
                        let ozellikList = data.subscriptionFeatureTypeResponseDtoList.map(obj => ({
                            ...obj,
                            disabled: obj.selected
                        }))
                        setSubscriptionFeatureTypeDtoList(ozellikList);
                    }

                } else {
                    if (data.subscriptionFeatureTypeResponseDtoList) {
                        setSubscriptionFeatureTypeDtoList(data.subscriptionFeatureTypeResponseDtoList);
                    }
                }

                setFeatureCount(data.selectedFeatureTypeCount);
                setReady(true);
                setValidIntervalEndDateTime(moment(data.validIntervalEndDateTime).format("YYYY-MM-DD"));
                setAhtapotValidIntervalEndDateTime(moment(data?.ahtapotSubscriptionViewDto?.ahtapotValidIntervalEndDateTime).format("YYYY-MM-DD"));
                setActiveTenantSubscription(data.validityStatusEnumValue);
                setActiveAhtapotenantSubscription(data?.ahtapotSubscriptionViewDto?.ahtapotValidityStatusEnumValue);
                if (data.selectedSubscriptionBillingTypeEnumValue === 'PRESALE_FIXED') {
                    setIsPresaleFixed(true);
                } else {
                    setIsPresaleFixed(false);
                }
                if (data.selectedAhtapotSubscriptionBillingTypeEnumValue === 'PRESALE_FIXED' || data.selectedAhtapotSubscriptionBillingTypeEnumValue === 'PRESALE_QUARTER' || data.selectedAhtapotSubscriptionBillingTypeEnumValue === 'PRESALE_YEAR') {
                    setHasAhtabotSubscription(true);
                } else {
                    setHasAhtabotSubscription(false);
                }
                setExpiryDayCount(data.expiryDayCount);
                setAhtapotExpiryDayCount(data?.ahtapotSubscriptionViewDto?.ahtapotExpiryDayCount);
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setLoginShow(true);

                }
            });

        fetch(couponManagementCheckUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
        }).then(res => {
            if (res.ok) {
                setHasCouponManagement(true)
            } else {
                setHasCouponManagement(false)
            }
        })

        fetch(adminManagementCheckUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
        }).then(res => {
            if (res.ok) {
                setHasAdminManagement(true)
            } else {
                setHasAdminManagement(false)
            }
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cookies.subscriptionToken]);


    useEffect(() => {
        if (!cookies.subscriptionToken) {
            toast.error(connectionErrorMessage, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }
        getDataTenantList();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cookies.subscriptionToken]);

    const getDataTenantList = (getAll = false) => {
        fetch(getAll ? getTenantList + "?allTenants=true" : getTenantList)
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setTenantList(data);
                handleRefreshClick();
            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setLoginShow(true);

                }
            });
    }

    const getDataMuvekkilTenantList = (isMuvekkilTenant) => {
        if(isMuvekkilTenant === false)
        {
            getDataTenantList(isAllTenants);
        }else {
            fetch(getAllMuvekkilTenants)
                .then(res => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error(errorMessage);
                    }
                })
                .then((data) => {
                    if (!data) {
                        return;
                    }
                    setTenantList(data);
                    handleRefreshClick();
                }, (error) => {
                    console.log(error);
                    if (error) {
                        toast.error(error.message, {
                            position: toast.POSITION.TOP_CENTER
                        });
                        setLoginShow(true);

                    }
                });
        }
    }


    const onChangeOpenUyapDosyaCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            let uyapDosyaCount = item.target.value;
            if (defaultTenantProperties && defaultTenantProperties.defaultUyapDosyaCount > uyapDosyaCount &&
                !item.nativeEvent.inputType && item.nativeEvent.inputType !== "insertText") {
                uyapDosyaCount = defaultTenantProperties.defaultUyapDosyaCount;
            }
            setRequestDto({
                ...requestDto,
                openUyapDosyaCount: uyapDosyaCount
            });
            setActionCount(actionCount + 1);
        }
    };

    const onChangeAhtapotFileCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            let fileCount = item.target.value;
            setAhtapotRequestDto({
                ...ahtapotRequestDto,
                ahtapotFileCount: fileCount
            });
            setActionCount(actionCount + 1);
        }
    };

    const onChangePayAmount = (item) => {
        if (item.target.value >= 0) {
            setPayAmount(item.target.value);
        }
    };

    const showAllTenants = (item) => {
        const checked = item?.target?.checked;

        if(isMuvekkilTenants===true){

            setIsMuvekkilTenants(false);
        }

        setIsAllTenants(checked);
        getDataTenantList(checked);
    };

    const showMuvekkilTenants= (item)=>{
        const checked = item?.target?.checked;

        if(isAllTenants===true) {
            setIsAllTenants(false);
        }

        if(checked === false){
            setIsMuvekkilTenantsWithoutSubscription(false);
        }

        setIsMuvekkilTenants(checked);
        getDataMuvekkilTenantList(checked)
    };

    const showMuvekkilTenantsWithoutSubscription=(item)=>{
        const checked = item?.target?.checked;

        setIsMuvekkilTenantsWithoutSubscription(checked);
        getDataMuvekkilTenantsWithoutSubscription(checked)
    };


    const getDataMuvekkilTenantsWithoutSubscription=(isMuvekkilTenantsWithoutSubscription)=>{
        if(isMuvekkilTenantsWithoutSubscription===true){

            fetch(getMuvekkilTenantsWithoutSubscription)
                .then(res => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error(errorMessage);
                    }
                })
                .then((data) => {
                    if (!data) {
                        return;
                    }
                    setTenantList(data);
                    handleRefreshClick();
                }, (error) => {
                    console.log(error);
                    if (error) {
                        toast.error(error.message, {
                            position: toast.POSITION.TOP_CENTER
                        });
                        setLoginShow(true);

                    }
                });
        }else {
            getDataMuvekkilTenantList(isMuvekkilTenants)
        }
    };


    const onChangeTokenCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            let tokenCount = item.target.value;
            if (defaultTenantProperties && defaultTenantProperties.defaultTokenCount > tokenCount &&
                !item.nativeEvent.inputType && item.nativeEvent.inputType !== "insertText") {
                tokenCount = defaultTenantProperties.defaultTokenCount;
            }
            setRequestDto({
                ...requestDto,
                tokenCount: tokenCount
            });
            setActionCount(actionCount + 1);
        }
    };
    const onChangeUserCount = (item) => {
        if (item.target.value >= 0 && item.target.value < maxCount) {
            let userCount = item.target.value;
            if (defaultTenantProperties && defaultTenantProperties.defaultUserCount > userCount &&
                !item.nativeEvent.inputType && item.nativeEvent.inputType !== "insertText") {
                userCount = defaultTenantProperties.defaultUserCount;
            }
            setRequestDto({
                ...requestDto,
                userCount: userCount
            });
            setActionCount(actionCount + 1);
        }
    };
    const onChangeValidIntervalEndDateTime = (item) => {
        setValidIntervalEndDateTime(item.target.value);
        setRequestDto({
            ...requestDto,
            validIntervalEndDateTime: moment(item.target.value, 'YYYY-MM-DD').valueOf()
        });
    };
    const onChangeAhtapotValidIntervalEndDateTime = (item) => {
        setAhtapotValidIntervalEndDateTime(item.target.value);
        setAhtapotRequestDto({
            ...ahtapotRequestDto,
            ahtapotValidIntervalEndDateTime: moment(item.target.value, 'YYYY-MM-DD').valueOf()
        });
    };
    const updateTenantSBR = () => {
        requestDto.subscriptionFeatureTypeRequestDtoList = selectedSubscriptionFeatureTypeDtoList;
        setRequestDto(requestDto);


        if (moment().valueOf() > requestDto.validIntervalEndDateTime) {
            toast.warning(WARNING_BEFORE_DATE_MSG, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        if (activeTenantSubscription !== "ACTIVE") {
            toast.error("Aktif UGY Üyeliği Bulunamadı!", {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        fetch(updateTenant, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify(requestDto)
        }).then(res => {
            if (res.ok) {
                toast.success("Kayıt değiştirildi.", {
                    position: toast.POSITION.TOP_CENTER
                });
                getDataTenantList();
                changeTenantId(selectionModel);
            } else {
                throw new Error(connectionErrorMessage);
            }
        })
    }

    const updateAhtapotTenantFileCount = () => {
        fetch(getAhtapotUpdateFileCountDtoUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify(tenantSubscriptionViewDto)
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setAhtapotUpdateFileCountDto(data);
                handleOpenUpdateFileCountFormDialog();
            }, (error) => {
                if (error) {
                    toast.error("Dosya Güncellemede Sorun Oluştu!", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }


    const handleOpenUpdateFileCountFormDialog = () => {
        setOpenUpdateFileCountFormDialog(true);
    };

    const handleCloseUpdateFileCountFormDialog = () => {
        setOpenUpdateFileCountFormDialog(false);
    };

    const updateAhtapotTenantSBR = () => {
        if (typeof ahtapotRequestDto.ahtapotValidIntervalEndDateTime !== 'number') {
            ahtapotRequestDto.ahtapotValidIntervalEndDateTime = moment(ahtapotRequestDto.ahtapotValidIntervalEndDateTime, 'YYYY-MM-DD').valueOf()
        }

        if (moment().valueOf() > ahtapotRequestDto.ahtapotValidIntervalEndDateTime) {
            toast.warning(WARNING_BEFORE_DATE_MSG, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        setAhtapotRequestDto(ahtapotRequestDto);

        if (activeAhtapotTenantSubscription !== "ACTIVE") {
            toast.error("Aktif Ahtabot Üyeliği Bulunamadı!", {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        fetch(updateAhtapot, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify(ahtapotRequestDto)
        }).then(res => {
            if (res.ok) {
                toast.success("Kayıt değiştirildi.", {
                    position: toast.POSITION.TOP_CENTER
                });
                getDataTenantList();
                changeTenantId(selectionModel);
            } else {
                throw new Error(connectionErrorMessage);
            }
        })
    }


    const changeToPresaleFixed = () => {
        requestDto.subscriptionFeatureTypeRequestDtoList = selectedSubscriptionFeatureTypeDtoList;
        setRequestDto(requestDto);

        if (moment().valueOf() > requestDto.validIntervalEndDateTime) {
            toast.warning(WARNING_BEFORE_DATE_MSG, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        fetch(changeToPresaleFixedUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify(requestDto)
        }).then(res => {
            if (res.ok) {
                toast.success("Kayıt faturalıya çevrildi.", {
                    position: toast.POSITION.TOP_CENTER
                });
                getDataTenantList();
                changeTenantId(selectionModel);
                return res.json();
            } else {
            toast.success("Bu işlemi yapabilmeniz için aktif üyeliğiniz bulunmalıdır!", {
                position: toast.POSITION.TOP_CENTER
            });
            }
        })
    }

    const onChangeFeatureAll = (itemChanged) => {
        if (itemChanged.target.checked) {
            let selectedDtoList = [];
            subscriptionFeatureTypeDtoList.map(function (item) {
                if (item.active) {
                    if (item.disabled !== true) {
                        item.selected = true;
                    }
                    selectedDtoList.push(item);
                }
                return item;
            });
            setSubscriptionFeatureTypeDtoList(subscriptionFeatureTypeDtoList);
            setSelectedSubscriptionFeatureTypeDtoList(selectedDtoList);
            setSelectAllFeatures(true);
            setFeatureCount(selectedDtoList.length);
            setActionCount(actionCount + 1);
        } else {
            subscriptionFeatureTypeDtoList.map((item) => {
                if (item.disabled !== true) {
                    item.selected = false;
                }
                return item;
            });
            setSubscriptionFeatureTypeDtoList(subscriptionFeatureTypeDtoList);
            setSelectedSubscriptionFeatureTypeDtoList([]);
            setSelectAllFeatures(false);
            setFeatureCount(0);
            setActionCount(0);
        }
    }

    const onChangeFeature = (itemChanged) => {

        if (!hasAdminManagement) {
            return;
        }

        let selectedSubscriptionFeatureTypeList = [];
        subscriptionFeatureTypeDtoList.map(function (item) {
            if (itemChanged.target.id.toString() === item.id.toString()) {
                item.selected = itemChanged.target.checked;
            }
            if (item.selected) {
                selectedSubscriptionFeatureTypeList.push(item);
            }
            return item;
        });
        setSubscriptionFeatureTypeDtoList(subscriptionFeatureTypeDtoList);
        setSelectedSubscriptionFeatureTypeDtoList(selectedSubscriptionFeatureTypeList);
        let newFeatureCount;
        if (itemChanged.target.checked) {
            newFeatureCount = featureCount + 1;
            setFeatureCount(newFeatureCount);
        } else {
            newFeatureCount = featureCount - 1;
            setFeatureCount(newFeatureCount);
        }

        if (newFeatureCount === 0) {
            setSelectAllFeatures(false);
        }
        setActionCount(actionCount + 1);
    };

    const onSelectionModelChange = (selection) => {
        const newSelectionModel = selection;
        setSelectedTenant(tenantList.find(t => t.id ===  newSelectionModel[0]));

        if (newSelectionModel.length > 1) {
            const selectionSet = new Set(selectionModel);
            const result = newSelectionModel.filter(
                (s) => !selectionSet.has(s)
            );
            setSelectionModel(result);
            changeTenantId(result);
        } else {
            setSelectionModel(newSelectionModel);
            changeTenantId(newSelectionModel)
        }

        if (newSelectionModel && !newSelectionModel.length > 0) {
            setTenantDataShow(null);
        }
    }

    const changeTenantId = (selectionModel, tabName) => {

        if (selectionModel === "undefined" || selectionModel === null || selectionModel === []
            || selectionModel.length === 0 || !selectionModel) {
            return
        }

        try {
            setTenantDataShow(false);
            fetch(selectTenantId + "/" + selectionModel, {
                method: 'GET',
                headers: {
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken),
                    'Content-Type': 'application/json'
                },
            }).then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error();
                }
            }).then((data) => {
                if (!data) {
                    return;
                }

                setSelectedTenant({ownerTenantId: data.ownerTenantId, tenantName: data.tenantName, hasAhtapotSubscription: data.hasAhtapotSubscription});
                getAhtapotSubscriptionInformationMessage(data,selectionModel);

                let selectedSubscriptionFeatureTypeRequestDtoList = [];
                if (data.subscriptionFeatureTypeResponseDtoList) {
                    data.subscriptionFeatureTypeResponseDtoList.map(function (item) {
                        if (item.selected) {
                            selectedSubscriptionFeatureTypeRequestDtoList.push(item);
                        }
                        return item;
                    });
                }

                setRequestDto(
                    {
                        activeDosyaCount: data.activeDosyaCount,
                        ugyActiveDosyaCountForAhtabot: data?.ugyActiveDosyaCountForAhtabot,
                        ahtabotUgyHediyeIslemGorecekDosyaGorevDetayAdet: data?.ahtabotUgyHediyeIslemGorecekDosyaGorevDetayAdet,
                        openUyapDosyaCount: data.openUyapDosyaCount || 100,
                        tokenCount: data.tokenCount || 1,
                        userCount: data.userCount || 1,
                        ownerTenantId: data.ownerTenantId,
                        validIntervalEndDateTime: data.validIntervalEndDateTime,
                        subscriptionFeatureTypeRequestDtoList: selectedSubscriptionFeatureTypeRequestDtoList
                    }
                );

                setAhtapotRequestDto(
                    {
                        ownerTenantId: data.ownerTenantId,
                        ahtapotValidIntervalEndDateTime: data?.ahtapotSubscriptionViewDto?.ahtapotValidIntervalEndDateTime,
                        ahtapotFileCount: data?.ahtapotSubscriptionViewDto?.ahtapotFileCount,
                        activeDosyaCountAhtapot: data.ahtapotSubscriptionViewDto?.activeDosyaCountAhtapot

                    }
                );

                setSelectedSubscriptionFeatureTypeDtoList(selectedSubscriptionFeatureTypeRequestDtoList);
                setTenantSubscriptionViewDto({
                    ...data,
                    ownerTenantId: data?.ownerTenantId ? data.ownerTenantId:
                        selectionModel.length > 0 ? selectionModel[0]:null
                });

                if (data.selectedSubscriptionBillingTypeEnumValue !== "PRESALE_DEMO") {
                    setDefaultTenantProperties({
                        defaultUyapDosyaCount: data.openUyapDosyaCount,
                        defaultTokenCount: data.tokenCount,
                        defaultUserCount: data.userCount
                    });

                    if (data.subscriptionFeatureTypeResponseDtoList) {
                        if (data.selectedSubscriptionBillingTypeEnumValue !== "PRESALE_FIXED") {
                            let ozellikList = data.subscriptionFeatureTypeResponseDtoList.map(obj => ({
                                ...obj,
                                disabled: obj.selected
                            }))
                            setSubscriptionFeatureTypeDtoList(ozellikList);
                        } else {
                            let ozellikList = data.subscriptionFeatureTypeResponseDtoList.map(obj => ({
                                ...obj
                            }))
                            setSubscriptionFeatureTypeDtoList(ozellikList);
                        }

                    }

                } else {
                    if (data.subscriptionFeatureTypeResponseDtoList) {
                        setSubscriptionFeatureTypeDtoList(data.subscriptionFeatureTypeResponseDtoList);
                    }
                }

                setFeatureCount(data.selectedFeatureTypeCount);
                setValidIntervalEndDateTime(moment(data.validIntervalEndDateTime).format("YYYY-MM-DD"));
                setAhtapotValidIntervalEndDateTime(moment(data?.ahtapotSubscriptionViewDto?.ahtapotValidIntervalEndDateTime).format("YYYY-MM-DD"));
                setActiveTenantSubscription(data.validityStatusEnumValue);
                setActiveAhtapotenantSubscription(data?.ahtapotSubscriptionViewDto?.ahtapotValidityStatusEnumValue);
                if (data.selectedSubscriptionBillingTypeEnumValue === 'PRESALE_FIXED') {
                    setIsPresaleFixed(true);
                } else {
                    setIsPresaleFixed(false);
                }
                if (data.selectedAhtapotSubscriptionBillingTypeEnumValue === 'PRESALE_FIXED' || data.selectedAhtapotSubscriptionBillingTypeEnumValue === 'PRESALE_QUARTER' || data.selectedAhtapotSubscriptionBillingTypeEnumValue === 'PRESALE_YEAR') {
                    setHasAhtabotSubscription(true);
                } else {
                    setHasAhtabotSubscription(false);
                }
                setExpiryDayCount(data.expiryDayCount);
                setAhtapotExpiryDayCount(data?.ahtapotSubscriptionViewDto?.ahtapotExpiryDayCount);

                setReady(true);
                if (tabName) {
                    setTabKey(tabName);
                } else {
                    setTabKey("ahtapot");
                }
                if (data?.message === "SUBSCRIPTION_NOT_FOUND") {
                 if(isAllTenants === true){
                     setTenantDataShow(null);
                     return;
                 }else {
                     setTenantDataShow(true);
                 }

                }
                getHistoryData();
                setTimeout(() => {
                    setTenantDataShow(true)
                }, 1000)
            }, (error) => {
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setLoginShow(true);
                }

                setTimeout(() => {
                    setTenantDataShow(true)
                }, 1000)
            })

        } catch
            (e) {
            toast.error(errorMessage);
        }

    }

    const GenereateFeature = () => {
        return (
            <React.Fragment>{
                subscriptionFeatureTypeDtoList.map(function (ozellikler) {
                    return (
                        <tr key={ozellikler.id || 'TR'}
                            style={{lineHeight: 1.5, height: "10px", fontSize: 12, verticalAlign: "middle"}}>
                            <td>
                                <Form.Check
                                    type='checkbox'
                                    custom
                                    style={{"textAlign": "right", "verticalAlign": "right"}}
                                    id={ozellikler.id}
                                    checked={ozellikler.selected}
                                    onChange={onChangeFeature}
                                />
                            </td>
                            <td style={ozellikler.active ? {verticalAlign: "middle", "whiteSpace": "nowrap"} : {
                                verticalAlign: "middle",
                                color: "lightgrey",
                                "whiteSpace": "nowrap"
                            }}>
                                {!ozellikler.active || ozellikler.disabled}
                            </td>
                            <td style={ozellikler.active ? {verticalAlign: "middle", "whiteSpace": "nowrap"} : {
                                verticalAlign: "middle",
                                color: "lightgrey",
                                "whiteSpace": "nowrap"
                            }}>
                                <div>{ozellikler.name}
                                    <Tooltip title={ozellikler.tooltip ? "" : "Bilgi Yok"} aria-label="add">
                                        <InfoTwoTone style={{color: "rgb(0, 0, 139)", float: "right"}}
                                                     onClick={() => handleOpenTooltipModal(ozellikler)}/>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                    )
                })
            }
            </React.Fragment>);
    };


    const GenereateSelectedFeature = () => {
        return (
            <React.Fragment>{
                selectedSubscriptionFeatureTypeDtoList.sort(function (a, b) {
                    return a.disabled - b.disabled
                }).map(function (ozellikler) {
                    return (
                        <tr key={ozellikler.id || 'TR'}
                            style={{
                                lineHeight: 2, height: "10px", fontSize: 12, verticalAlign: "middle"
                                , color: (ozellikler.disabled === false) ? "red" : "black"
                            }}>
                            <td style={{verticalAlign: "middle"}}>
                                {ozellikler.subscriptionServiceFeatureCategoryTypeName}
                            </td>
                            <td style={{verticalAlign: "middle"}} title={ozellikler.tooltip}>
                                {ozellikler.name}
                            </td>
                        </tr>
                    )
                })
            }
            </React.Fragment>);
    };


    const openStatusDialog = (status, tenantId, type) => {
        setTenantSubscriptionStatusRequestDto({
            ownerTenantId: tenantId,
            status: status,
            type: type,
            validIntervalEndDateTime:validIntervalEndDateTime,
        })
        handleOpenStatusFormDialog();
    }

    const getHistoryData = () => {
        if (selectionModel && selectionModel.length > 0) {
            fetch(getPaymentHistoryUrl + "/" + selectionModel[0], {
                method: 'GET',
                headers: {
                    'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            }).then(res => {
                if (res.ok) {
                    return res.json();
                }
            }).then((data) => {
                if (!data) {
                    return;
                }

                moment.locale('tr')

                for (var i = 0; i < data.length; i++) {
                    data[i].id = i + '' + data[i].id;
                    data[i].validIntervalEndDateTime = moment(data[i].validIntervalEndDateTime).format("LLL");
                    data[i].validIntervalBeginDateTime = moment(data[i].validIntervalBeginDateTime).format("LLL");
                    data[i].paymentDatepaymentDate = moment(data[i].paymentDatepaymentDate).format("LLL");
                    data[i].lastModifiedDateTime = moment(data[i].lastModifiedDateTime).format("LLL");
                    data[i].featureCount = data[i].featureCount > 0 ? data[i].featureCount : "";
                }

                setPaymentHistoryData(data)
            })
        }
    }

    const handleRefreshClick = () => {
        setRefreshGrid(!refreshGrid);
    };

    const HeaderPart = () => {
        return (
            <Row>
                <Col lg={7} style={{"whiteSpace": "nowrap", "padding": "10"}}>
                    {tenantSubscriptionViewDto.userSubscriptionInformation}
                </Col>
            </Row>
        );
    };

    const HeaderPart1 = () => {
        return (
            <Row>
            <Col lg={7} style={{"whiteSpace": "nowrap", "padding": "10"}}>
        {tenantSubscriptionViewDto.userSubscriptionInformation2}
    </Col>
        </Row>
    );
    };

    const chooseTenant = () => {
        return <div style={{textAlign: "center", color: "grey"}}>
            <br/><br/><br/>
            <WarningTwoToneIcon style={{fontSize: "50px"}}/><br/><br/><h3>Lütfen Tablodan Hukuk Bürosu Seçiniz</h3>
        </div>;
    }

    const showTooltip=(params)=>{
        return (
            <Tooltip
                title={<div style={{ fontSize: '14px', padding: '8px' }}>{params?.value || ''}</div>}
                arrow
                placement="top"
                enterDelay={200}
                componentsProps={{
                    tooltip: {
                        sx: {
                            maxWidth: '600px',
                            bgcolor: 'white',
                            color: 'black',
                            border: '1px solid #ccc',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            '& .MuiTooltip-arrow': {
                                color: 'white',
                                '&::before': {
                                    border: '1px solid #ccc'
                                }
                            }
                        }
                    }
                }}
            >
                <div className="overflow-hidden text-ellipsis whitespace-nowrap max-w-full">
                    {params?.value}
                </div>
            </Tooltip>
        )
    };

    const getAhtapotSubscriptionInformationMessage=(tenantSubscriptionViewDto,selectionModel)=>{
        if(tenantSubscriptionViewDto.localizedMessage==='SUBSCRIPTION_NOT_FOUND'){
           if(selectionModel !== null && selectionModel.length > 0){

                tenantList.forEach((item)=>{
                    if(item.id === selectionModel[0] ){
                        const message = `${item.hbTamAdi} - Aktif Aboneliğiniz Bulunmamaktadır!`;
                        setAhtapotSubscriptionInformationText(message);
                        return;
                    }
                });
            } else {
               setAhtapotSubscriptionInformationText('Aktif Aboneliğiniz Bulunmamaktadır!');
           }
        }else {
            setAhtapotSubscriptionInformationText(tenantSubscriptionViewDto.ahtapotSubscriptionInformation);
        }

    }

    if (ready) {

        const columns = [
            {
                field: 'hbTamAdi',
                headerName: 'Adı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 200,
                renderCell: params => (
                   showTooltip(params)
                )
            },
            {
                field: 'hbVergiDairesi',
                headerName: 'Vergi Dairesi',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 200
            },
            {
                field: 'hbVergiSicilNo',
                headerName: 'Vergi Sicil No',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 200
            },
            {
                field: 'referenceCode',
                headerName: 'Referans No',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 150
            },
            {
                field: 'hbTelNo',
                headerName: 'Tel No',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 120
            },
            {
                field: 'hbIlName',
                headerName: 'İl',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 100
            },
            {
                field: 'hbIlceName',
                headerName: 'İlçe',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 100
            },
            {
                field: 'hbAdres',
                headerName: 'Adres',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 300,
                renderCell: params => (
                    showTooltip(params)
                )
            },
            {
                field: 'hbMail',
                headerName: 'Mail Adresi',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 200,
                renderCell: params => (
                    showTooltip(params)
                )
            },
            {
                field: 'abonelikAdi',
                headerName: 'Abonelik Adı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 200
            },
            {
                field: 'abonelikTipi',
                headerName: 'Abonelik Tipi',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 200
            },
            {
                field: 'durumu',
                headerName: 'Durumu',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                renderCell: (params: GridRenderCellParams) => (
                    <strong style={{color: (params.value === "Aktif" ? "GREEN" : "RED")}}>
                        {(params.value)}
                    </strong>
                ),
                width: 200
            },
        ];

        const paymentHistoryColumns = [
            {
                field: 'subscriptionBillingTypeEnumValue',
                headerName: 'Abonelik Tipi',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 160
            },
            {
                field: 'discountCouponName',
                headerName: 'Kampanya Adı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                hide: !hasCouponManagement,
                width: 160
            },
            {
                field: 'validIntervalBeginDateTime',
                type: 'dateTime',
                headerName: 'Abonelik Başlangıç Tarihi',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 220
            },
            {
                field: 'validIntervalEndDateTime',
                type: 'dateTime',
                headerName: 'Abonelik Bitiş Tarihi',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 200
            },
            {
                field: 'lastModifiedDateTime',
                type: 'dateTime',
                headerName: 'Son Değişiklik Tarihi',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 180
            },
            {
                field: 'paymentAmountWithCommission',
                headerName: 'Ödenen Ücret',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 160,
                valueFormatter: ({value}) => (value ? currencyFormatter.format(Number(value)) : null),
            }, {
                field: 'installmentIndex',
                headerName: 'Taksit Sayısı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                renderCell: (params: GridRenderCellParams) => (
                    <strong>
                        {params.value > 1 ? (params.value) : "Tek Çekim"}
                    </strong>
                ),
                width: 150
            },
            {
                field: 'installmentAmount',
                headerName: 'Taksit Tutarı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                valueFormatter: ({value}) => (value ? currencyFormatter.format(Number(value)) : null),
                width: 150
            },
            {
                field: 'bankCommissionAmount',
                headerName: 'Banka Kom. Tutarı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                valueFormatter: ({value}) => (value ? currencyFormatter.format(Number(value)) : null),
                width: 150
            },
            {
                field: 'discountCouponName',
                headerName: 'Uygulanan Kampanya',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 150
            },
            {
                field: 'featureCount',
                headerName: 'Özellik Sayısı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 120
            },
            {
                field: 'userCount',
                headerName: 'Kullanıcı Sayısı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 140
            },
            {
                field: 'tokenCount',
                headerName: 'Token Sayısı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 140
            },
            {
                field: 'purchasedReferenceCode',
                headerName: 'Satın Alınan Referans Kodu',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 180
            },
            {
                field: 'referenceTenant',
                headerName: 'Kampanya İlişkili Hukuk Bürosu',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 180
            },
            {
                field: 'openUyapDosyaCount',
                headerName: 'Açık Dosya Sayısı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 170
            },
            {
                field: 'activeDosyaCount',
                headerName: 'İşlem Yapılan Dosya Sayısı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 220
            },
            {
                field: 'activeDosyaCountAhtapot',
                headerName: 'Ahtabot İşlem Yapılan Dosya Sayısı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 220
            },
            {
                field: 'lastUpdatedBy',
                headerName: 'Değişikliği Yapan Kullanıcı',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 220
            },
            {
                field: 'status',
                headerName: 'Abonelik Durumu',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                renderCell: (params: GridRenderCellParams) => (
                    <strong style={{color: (params.value === "Aktif" ? 'GREEN' : "RED")}}>
                        {(params.value)}
                    </strong>
                ),
                width: 140
            },
            {
                field: 'paymentStatus',
                headerName: 'Ödeme Durumu',
                headerAlign: 'center',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                renderCell: (params: GridRenderCellParams) => (
                    <strong style={{color:(!params.row?.paymentAmount ? "BLUE" : params.value === "SUCCESS" ? 'GREEN' : "RED")}}>
                        {!params.row?.paymentAmount ? "Ödemesiz İşlem" : params.value === "SUCCESS" ? "Başarılı" : "Hatalı"}
                    </strong>
                ),
                width: 140
            },
            {
                field: 'paymentRemark',
                headerName: 'Ödeme Açıklama',
                headerAlign: 'left',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 400,
                renderCell: params => (
                    showTooltip(params)
                )
            },
            {
                field: 'remark',
                headerName: 'Açıklama',
                headerAlign: 'left',
                headerClassName: 'cell-header',
                cellClassName: 'cell-data',
                width: 300,
                renderCell: params => (
                    showTooltip(params)
                )
            },
            //{ field: 'odeme_yapilan_kart_bilgileri', headerName: 'Ödeme Yapılan Kart Bilgileri', headerAlign: 'center', headerClassName: 'cell-header', cellClassName: 'cell-data',width: 200 }

        ];

        return (
            <div className="overflow-hidden containerWrapper">
                {hasAdminManagement || hasCouponManagement ?
                    <button style={{float: "right", "fontSize": 16, "fontWeight": "bold", color: "#00008B"}}
                            onClick={() => {
                                setReady(false);
                                setShowDiscountManagerPanel(true)
                            }}>Kampanya Oluştur</button> : null}
                <Helmet>
                    <title>{helmetTitle}</title>
                </Helmet>
                <Tabs
                    className="pt-1 pl-3 tabsColor"
                    id="subscription-tabs"
                    transition={false}
                    activeKey={firstTabKey}
                    onSelect={(k) => setFirstTabKey(k)}>

                    <Tab eventKey="tenantTab" title="Hukuk Büro Listesi" className="shadow p-3 mb-1 bg-white rounded">
                        <div style={{display: 'inline-flex', width: '98%'}}>
                            <Form.Check className="justify-content-start labelWrapper pl-5"
                                        type='checkbox'
                                        label="Üyeliği Olmayan Büroları da Göster"
                                        checked={isAllTenants}
                                        onChange={showAllTenants}
                            />
                            <Form.Label className="justify-content-end labelWrapper pl-5">{isMuvekkilTenants ? 'Müvekkil sayısı':'Kurum Sayısı'}
                                : {tenantList.length}</Form.Label>
                            {hasAdminManagement && (
                                <Form.Check
                                    className="justify-content-start labelWrapper pl-5"
                                    type='checkbox'
                                    label="Müvekkil Tenantları Göster"
                                    checked={isMuvekkilTenants}
                                    onChange={showMuvekkilTenants}
                                />
                            )}
                            {hasAdminManagement && isMuvekkilTenants && (
                                <Form.Check
                                    className="justify-content-start labelWrapper pl-5"
                                    type='checkbox'
                                    label="Üyeliği Olmayan Müvekkil Tenantları Göster"
                                    checked={isMuvekkilTenantsWithoutSubscription}
                                    onChange={showMuvekkilTenantsWithoutSubscription}
                                />
                            )}
                        </div>

                        <Row>
                            <div style={{
                                width: "100%",
                                height: "100%"
                            }}>
                                <Card style={{
                                    borderBottom: 0
                                }}>
                                    <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                               style={{
                                                   width: "100%",
                                                   height: "22em",
                                                   padding: '0 !important'
                                               }}>
                                        <EtcDataGrid
                                            refreshGrid={refreshGrid}
                                            onSelectionModelChange={onSelectionModelChange}
                                            data={tenantList}
                                            columns={columns}
                                            pageSize={8}
                                            selectionModel={selectionModel}/>

                                    </Card.Body>
                                </Card>
                            </div>
                        </Row>
                    </Tab>
                </Tabs>
                {tenantDataShow ? <Tabs
                    className="pt-1 pl-3 tabsColor"
                    id="subscription-tabs"
                    activeKey={tabKey}
                    onSelect={(k) => {
                        if ("history") {
                            getHistoryData();
                        }
                        setTabKey(k)
                    }}
                >

                    <Tab eventKey="ahtapot" title="Ahtabot Abonelik">
                        <Row style={{fontSize: 16}}>
                            <Col>
                                <Card>
                                    <Card.Header as="h5"
                                                 className="align-items-center align-middle p-1 font-weight-bold">
                                        <Row>
                                            <Col lg={7} style={{"whiteSpace": "nowrap", "padding": "10"}}>
                                                {ahtapotSubscriptionInformationText}
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <div style={{
                                width: "30%"
                            }} className="pl-3 pr-0">
                                <Card>
                                    <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                               style={{fontSize: 12}}>
                                        <Table striped bordered hover responsive size="sm">
                                            <tbody>
                                            <tr style={{height: 10}}>
                                                <td>
                                                </td>
                                                <td style={{
                                                    height: 10,
                                                    "textAlign": "center",
                                                    "verticalAlign": "middle",
                                                    width: "40%"
                                                }}>
                                                    <Form.Label style={{height: 10}}>
                                                        Adet
                                                    </Form.Label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 align-middle pl-1" style={{height: 10}}>
                                                        Ahtabot İşlem Yapılan Dosya Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td style={{"textAlign": "end", "verticalAlign": "middle"}}>
                                                    <FormControl column="lg" lg={2}
                                                                 type='number'
                                                                 disabled={true}
                                                                 className="text-right align-items-end pl-4"
                                                                 style={{fontSize: 10}}
                                                                 value={ahtapotRequestDto.activeDosyaCountAhtapot}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 pl-1 align-middle"
                                                                style={{"whiteSpace": "nowrap"}}>
                                                        Ahtabot İşlem Yapılacak Dosya Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td className="justify-content-end" style={{"whiteSpace": "nowrap"}}>
                                                    <FormControl type='number'
                                                                 className="text-right justify-content-end pl-4"
                                                                 disabled={!hasAdminManagement}
                                                                 style={{fontSize: 10}}
                                                                 value={ahtapotRequestDto.ahtapotFileCount}
                                                                 onChange={onChangeAhtapotFileCount}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 pl-1 align-middle"
                                                                style={{"whiteSpace": "nowrap"}}>
                                                        UGY İşlem Yapılan Dosya Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td className="justify-content-end" style={{"whiteSpace": "nowrap"}}>
                                                    <FormControl type='number'
                                                                 className="text-right justify-content-end pl-4"
                                                                 placeholder="Adet"
                                                                 disabled={true}
                                                                 style={{fontSize: 10}}
                                                                 value={requestDto?.ugyActiveDosyaCountForAhtabot}
                                                    />
                                                </td>
                                            </tr>                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 pl-1 align-middle"
                                                                style={{"whiteSpace": "nowrap"}}>
                                                        Ahtabot Hediye UGY İşlenebilir Görev Detay Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td className="justify-content-end" style={{"whiteSpace": "nowrap"}}>
                                                    <FormControl type='number'
                                                                 className="text-right justify-content-end pl-4"
                                                                 placeholder={requestDto?.ahtabotUgyHediyeIslemGorecekDosyaGorevDetayAdet ? "Adet" : undefined}
                                                                 disabled={true}
                                                                 style={{fontSize: 10}}
                                                                 value={requestDto?.ahtabotUgyHediyeIslemGorecekDosyaGorevDetayAdet}
                                                    />
                                                </td>
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                                <Card>
                                    <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                               style={{fontSize: 12}}>
                                        <Table striped bordered hover responsive size="sm">
                                            <tbody>
                                            <tr style={{height: 10}}>
                                                <td>
                                                </td>
                                                <td style={{
                                                    height: 10,
                                                    "textAlign": "center",
                                                    "verticalAlign": "middle",
                                                    width: "40%"
                                                }}>
                                                    <Form.Label style={{height: 10}}>
                                                        Üyelik Süresi
                                                    </Form.Label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 pl-1 align-middle"
                                                                style={{"whiteSpace": "nowrap"}}>
                                                        Kalan Gün Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td className="justify-content-end" style={{"whiteSpace": "nowrap"}}>
                                                    <FormControl type='number'
                                                                 className="text-right justify-content-end pl-4"
                                                                 style={{fontSize: 10}}
                                                                 value={ahtapotExpiryDayCount}
                                                                 disabled={true}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{verticalAlign: 'bottom'}}>
                                                    <Form.Label className="pt-1 align-middle pl-1">
                                                        Üyelik Bitiş Tarihi
                                                    </Form.Label>
                                                </td>
                                                <td>
                                                    <TextField style={{
                                                        width: '-webkit-fill-available',
                                                        backgroundColor: 'white',
                                                        verticalAlign: 'bottom'
                                                    }}
                                                               inputProps={{
                                                                   style: {textAlign: 'end', fontSize: '12px'}
                                                               }}
                                                               disabled={!hasAdminManagement}
                                                               variant="filled"
                                                               size="small"
                                                               id="dateAhtapot"
                                                               type="date"
                                                               format="MM/dd/yyyy"
                                                               defaultValue={ahtapotValidIntervalEndDateTime}
                                                               value={ahtapotValidIntervalEndDateTime}
                                                               onChange={onChangeAhtapotValidIntervalEndDateTime}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {hasAdminManagement && (
                                                        <div className="flex gap-4">
                                                            <div className="">
                                                                <Button
                                                                    variant="primary"
                                                                    size="sm"
                                                                    className="mr-2 mb-2 bg-blue-500 hover:bg-blue-600 border-0 h-8"
                                                                    onClick={updateAhtapotTenantSBR}
                                                                >
                                                                    Kaydet
                                                                </Button>
                                                                <Button
                                                                    disabled={!tenantSubscriptionViewDto?.hasAhtapotSubscription}
                                                                    variant={tenantSubscriptionViewDto?.hasAhtapotSubscription ? "info" : "outline-secondary"}                                                             size="sm"
                                                                    className="mb-2 bg-gray-500 hover:bg-gray-600 border-0 h-8"
                                                                    onClick={updateAhtapotTenantFileCount}
                                                                >
                                                                    Dosya Sayısı Güncelle
                                                                </Button>
                                                            </div>

                                                            <div className="flex flex-col space-y-2">
                                                                {activeAhtapotTenantSubscription !== "ACTIVE" ?
                                                                    <Button
                                                                        variant="success"
                                                                        size="sm"
                                                                        className="mr-2 mb-2 bg-green-500 hover:bg-green-600 border-0 h-8"
                                                                        onClick={() => openStatusDialog("active", selectionModel[0], "AHTAPOT")}
                                                                    >
                                                                        Aktif Et
                                                                    </Button> :
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        className="mr-2 mb-2 bg-green-500 hover:bg-green-600 border-0 h-8"
                                                                        onClick={() => openStatusDialog("passive", selectionModel[0], "AHTAPOT")}
                                                                    >
                                                                        Pasif Et
                                                                    </Button>
                                                                }
                                                                <Button
                                                                    variant="warning"
                                                                    size="sm"
                                                                    className="mb-2 pr-5 bg-blue-500 hover:bg-blue-600 border-0 h-8"
                                                                    onClick={handleOpenMembershipModalDialog}
                                                                >
                                                                    Faturalıya Çevir
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    {hasAdminManagement && <Button className="m-1"
                                                                                   style={{
                                                                                       height: "65px",
                                                                                       backgroundColor: (tenantSubscriptionViewDto?.hasAhtapotSubscription) ? 'grey' : '#3300cc'
                                                                                   }}
                                                                                   size="sm"
                                                                                   disabled={tenantSubscriptionViewDto?.hasAhtapotSubscription}
                                                                                   onClick={startAhtapotDemo}>500 Adet
                                                        Dosya İçin 1 Aylık
                                                        AhtaBot Demo Kullanımı Başlat</Button>}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Row>

                        <TooltipDialog
                            open={openTooltipModal}
                            handleClose={handleCloseTooltipModal}
                            title={toolTipTitle}
                            text={toolTipText}
                        />

                        <MembershipModalDialog
                            openDialog={isMembershipModalDialogOpen}
                            ahtapotRequestDto={ahtapotRequestDto}
                            currentBillingTypeEnumValue={tenantSubscriptionViewDto?.selectedAhtapotSubscriptionBillingTypeEnumValue}
                            remainingDayCount={ahtapotExpiryDayCount}
                            getDataTenantList={getDataTenantList}
                            changeTenantId={changeTenantId}
                            selectionModel={selectionModel}
                            handleCloseDialog={() => setIsMembershipModalDialogOpen(false)}
                        />
                        <DetailListDialog
                            open={openDetailListDialogModal}
                            handleClose={handleCloseDetailListDialogModal}
                            list={<Table striped bordered hover responsive size="sm">
                                <thead>
                                <tr style={{"fontSize": 12, "fontWeight": "bold", color: "#00008B"}}>
                                    <th style={{
                                        "verticalAlign": "middle",
                                        "textAlign": "center",
                                        width: "40%",
                                        "whiteSpace": "nowrap"
                                    }}>
                                        Seçilen Özellik Kategorisi
                                    </th>
                                    <th style={{
                                        "verticalAlign": "middle",
                                        "textAlign": "center",
                                        width: "60%",
                                        "whiteSpace": "nowrap"
                                    }}>
                                        Seçilen Özellik Adı
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="align-items-center align-middle">
                                <GenereateSelectedFeature/>
                                </tbody>
                            </Table>}
                        />
                        <FormDialog
                            openDialog={openStatusFormDialog}
                            handleAcceptDialog={handleAcceptStatusFormDialog}
                            handleCloseDialog={handleCloseStatusFormDialog}
                            color={tenantSubscriptionStatusRequestDto.status === 'active' ? 'green' : 'red'}
                            title={tenantSubscriptionStatusRequestDto.status === 'active' ? "Aktif Et" : "Pasif Et"}
                            dialogContentText={"İşlemin tamamlanması bir açıklama giriniz!"}
                        />

                    </Tab>
                    <Tab eventKey="payment" title="UGY Abonelik">
                    <Row style={{fontSize: 16}}>
                        <Col>
                        <Card>
                            <Card.Header as="h5"
                                className="align-items-center align-middle p-1 font-weight-bold">
                                    <HeaderPart1/>
                                    </Card.Header>
                        </Card>
                        </Col>
                        </Row>
                        <Row style={{fontSize: 16}}>
                            <Col>
                                <Card>
                                    <Card.Header as="h5"
                                                 className="align-items-center align-middle p-1 font-weight-bold">
                                        <HeaderPart/>
                                    </Card.Header>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <div style={{
                                width: "23%"
                            }} className="pl-3 pr-0">
                                <Card>
                                    <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                               style={{fontSize: 12}}>
                                        <Table striped bordered hover responsive size="sm">
                                            <tbody>
                                            <tr style={{height: 10}}>
                                                <td style={{
                                                    width: "55%"
                                                }}>
                                                </td>
                                                <td style={{
                                                    height: 10,
                                                    "textAlign": "center",
                                                    "verticalAlign": "middle"
                                                }}>
                                                    <Form.Label style={{height: 10}}>
                                                        Adet
                                                    </Form.Label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 align-middle pl-1" style={{height: 10}}>
                                                        İşlem Yapılan Dosya Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td style={{"textAlign": "end", "verticalAlign": "middle"}}>
                                                    <FormControl column="lg" lg={2}
                                                                 type='number'
                                                                 disabled={true}
                                                                 className="text-right align-items-end pl-4"
                                                                 style={{fontSize: 10}}
                                                                 value={requestDto.activeDosyaCount}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 pl-1 align-middle"
                                                                style={{"whiteSpace": "nowrap"}}>
                                                        İşlem Yapılacak Dosya Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td className="justify-content-end" style={{"whiteSpace": "nowrap"}}>
                                                    <FormControl type='number'
                                                                 className="text-right justify-content-end pl-4"
                                                                 placeholder="Adet"
                                                                 disabled={!hasAdminManagement}
                                                                 style={{fontSize: 10}}
                                                                 value={requestDto.openUyapDosyaCount}
                                                                 onChange={onChangeOpenUyapDosyaCount}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 align-middle pl-1">
                                                        TOKEN'lı Avukat Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td>
                                                    <FormControl
                                                        type='number'
                                                        placeholder="Adet"
                                                        className="text-right pl-4"
                                                        style={{fontSize: 10}}
                                                        disabled={!hasAdminManagement}
                                                        value={requestDto.tokenCount}
                                                        onChange={onChangeTokenCount}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 align-middle pl-1">
                                                        Kullanıcı Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td>
                                                    <div className="justify-content-end align-middle ">
                                                        <FormControl
                                                            placeholder="Adet"
                                                            type='number'
                                                            disabled={!hasAdminManagement}
                                                            className="text-right align-items-end pl-4"
                                                            style={{fontSize: 10}}
                                                            value={requestDto.userCount}
                                                            onChange={onChangeUserCount}
                                                        />
                                                    </div>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 align-middle pl-1" style={{height: 10}}>
                                                        Özellik Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td style={{"textAlign": "end", "verticalAlign": "middle"}}>
                                                    <FormControl
                                                        type='number'
                                                        disabled={true}
                                                        className="text-right align-items-end pl-4"
                                                        style={{fontSize: 10}}
                                                        value={featureCount}
                                                    />
                                                </td>
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                                <Card>
                                    <Card.Body className="align-items-center align-middle font-weight-bold p-1"
                                               style={{fontSize: 12}}>
                                        <Table striped bordered hover responsive size="sm">
                                            <tbody>
                                            <tr style={{height: 10}}>
                                                <td style={{
                                                    width: "55%"
                                                }}>
                                                </td>
                                                <td style={{
                                                    height: 10,
                                                    "textAlign": "center",
                                                    "verticalAlign": "middle"
                                                }}>
                                                    <Form.Label style={{height: 10}}>
                                                        Üyelik Süresi
                                                    </Form.Label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <Form.Label className="pt-1 pl-1 align-middle"
                                                                style={{"whiteSpace": "nowrap"}}>
                                                        Kalan Gün Sayısı
                                                    </Form.Label>
                                                </td>
                                                <td className="justify-content-end" style={{"whiteSpace": "nowrap"}}>
                                                    <FormControl type='number'
                                                                 className="text-right justify-content-end pl-4"
                                                                 style={{fontSize: 10}}
                                                                 value={expiryDayCount}
                                                                 disabled={true}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{verticalAlign: 'bottom'}}>
                                                    <Form.Label className="pt-1 align-middle pl-1">
                                                        Üyelik Bitiş Tarihi
                                                    </Form.Label>
                                                </td>
                                                <td>
                                                    <TextField style={{
                                                        width: '-webkit-fill-available',
                                                        backgroundColor: 'white',
                                                        verticalAlign: 'bottom'
                                                    }}
                                                               inputProps={{
                                                                   style: {textAlign: 'end', fontSize: '12px'}
                                                               }}
                                                               disabled={!hasAdminManagement}
                                                               variant="filled"
                                                               size="small"
                                                               id="date"
                                                               type="date"
                                                               format="MM/dd/yyyy"
                                                               defaultValue={validIntervalEndDateTime}
                                                               value={validIntervalEndDateTime}
                                                               onChange={onChangeValidIntervalEndDateTime}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{border: 0}}>
                                                    {hasAdminManagement &&
                                                        <div className="pl-2 pt-2" style={{display: 'flex'}}>
                                                            <Button className="mr-2" variant="info" size="sm" active
                                                                    style={{height: "60px"}}
                                                                    onClick={updateTenantSBR}>Kaydet</Button>
                                                            {activeTenantSubscription !== "ACTIVE" ?
                                                                <Button variant="success" size="sm"
                                                                        style={{height: "60px"}} onClick={() => {
                                                                    openStatusDialog("active", selectionModel[0], "UGY")
                                                                }}>Aktif Et</Button>
                                                                : <Button variant="danger" size="sm"
                                                                          style={{height: "60px"}} onClick={() => {
                                                                    openStatusDialog("passive", selectionModel[0], "UGY")
                                                                }}>Pasif Et</Button>}
                                                            <Button className="ml-2" style={{height: "60px"}}
                                                                    variant="primary" size="sm"
                                                                    disabled={isPresaleFixed}
                                                                    onClick={changeToPresaleFixed}>Faturalıya
                                                                Çevir</Button>

                                                        </div>}
                                                </td>

                                                <td>
                                                    {hasAdminManagement && <Button className="m-1"
                                                                                   style={{
                                                                                       height: "65px",
                                                                                       backgroundColor: tenantSubscriptionViewDto?.validityStatusEnumValue === 'ACTIVE' ? 'grey' : '#3300cc'
                                                                                   }}
                                                                                   size="sm"
                                                                                   disabled={tenantSubscriptionViewDto?.validityStatusEnumValue === 'ACTIVE'}
                                                                                   onClick={startUgyDemo}>100 Adet
                                                        Dosya İçin 15 Günlük
                                                        UGY Demo Kullanımı Başlat</Button>}
                                                </td>

                                            </tr>
                                            </tbody>

                                        </Table>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div style={{
                                width: "42%"
                            }} className="pl-0 pr-0">
                                <Card>
                                    <Card.Body className="p-1">
                                        <div style={{maxHeight: "450px", overflowY: "scroll", border: "black"}}>
                                            <Table striped bordered hover size="sm">
                                                <thead>
                                                <tr style={{"fontSize": 12, "fontWeight": "bold", color: "#00008B"}}>
                                                    <th style={{"fontSize": 12, width: "5%"}}>
                                                        <Form.Check
                                                            type='checkbox'
                                                            custom
                                                            style={{"textAlign": "right", "verticalAlign": "right"}}
                                                            id="selectAllFeaturesId"
                                                            checked={selectAllFeatures}
                                                            onChange={onChangeFeatureAll}
                                                        />
                                                    </th>
                                                    <th style={{
                                                        "verticalAlign": "middle",
                                                        "textAlign": "center",
                                                        "whiteSpace": "nowrap"
                                                    }}>
                                                        Özellik Kategorisi
                                                    </th>
                                                    <th style={{
                                                        "verticalAlign": "middle",
                                                        "textAlign": "center",
                                                        "whiteSpace": "nowrap"
                                                    }}>
                                                        Özellik Adı
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody className="align-items-center align-middle">
                                                <GenereateFeature/>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div style={{
                                width: "35%"
                            }} className="pr-3 pl-0">
                                <Card>
                                    <Card.Body className="p-1">
                                        <div style={{maxHeight: "450px", overflowY: "scroll", border: "black"}}>
                                            <Table striped bordered hover responsive size="sm">
                                                <thead>
                                                <tr style={{"fontSize": 12, "fontWeight": "bold", color: "#00008B"}}>
                                                    <th style={{
                                                        "verticalAlign": "middle",
                                                        "textAlign": "center",
                                                        width: "40%",
                                                        "whiteSpace": "nowrap"
                                                    }}>
                                                        Seçilen Özellik Kategorisi
                                                    </th>
                                                    <th style={{
                                                        "verticalAlign": "middle",
                                                        "textAlign": "center",
                                                        width: "60%",
                                                        "whiteSpace": "nowrap"
                                                    }}>
                                                        Seçilen Özellik Adı
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody className="align-items-center align-middle">
                                                <GenereateSelectedFeature/>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Row>
                        <TooltipDialog
                            open={openTooltipModal}
                            handleClose={handleCloseTooltipModal}
                            title={toolTipTitle}
                            text={toolTipText}
                        />
                        <DetailListDialog
                            open={openDetailListDialogModal}
                            handleClose={handleCloseDetailListDialogModal}
                            list={<Table striped bordered hover responsive size="sm">
                                <thead>
                                <tr style={{"fontSize": 12, "fontWeight": "bold", color: "#00008B"}}>
                                    <th style={{
                                        "verticalAlign": "middle",
                                        "textAlign": "center",
                                        width: "40%",
                                        "whiteSpace": "nowrap"
                                    }}>
                                        Seçilen Özellik Kategorisi
                                    </th>
                                    <th style={{
                                        "verticalAlign": "middle",
                                        "textAlign": "center",
                                        width: "60%",
                                        "whiteSpace": "nowrap"
                                    }}>
                                        Seçilen Özellik Adı
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="align-items-center align-middle">
                                <GenereateSelectedFeature/>
                                </tbody>
                            </Table>}
                        />
                        <FormDialog
                            openDialog={openStatusFormDialog}
                            handleAcceptDialog={handleAcceptStatusFormDialog}
                            handleCloseDialog={handleCloseStatusFormDialog}
                            color={tenantSubscriptionStatusRequestDto.status === 'active' ? 'green' : 'red'}
                            title={tenantSubscriptionStatusRequestDto.status === 'active' ? "Aktif Et" : "Pasif Et"}
                            dialogContentText={"İşlemin tamamlanması bir açıklama giriniz!"}
                        />

                        <AhtapotUpdateFileCountFormDialog
                            tenantSubscriptionViewDto={tenantSubscriptionViewDto}
                            ahtapotUpdateFileCountDto={ahtapotUpdateFileCountDto}
                            openDialog={openUpdateFileCountFormDialog}
                            handleCloseDialog={handleCloseUpdateFileCountFormDialog}
                            refreshTab={() => {
                                changeTenantId(selectionModel);
                            }}
                            color={'blue'}
                            title={"Dosya Sayısı Güncelle"}
                        />
                    </Tab>
                    <Tab eventKey="history" title="Abonelik/Ödeme Bilgileri Göster">
                        <Row>
                            <div style={{ width: "100%", height: "100%" }}>
                                <Card style={{ borderBottom: 0 }}>
                                    <Card.Body
                                        className="font-weight-bold p-1"
                                        style={{
                                            width: "100%",
                                            height: "500px",
                                            display: "flex",
                                            flexDirection: "column",
                                            padding: 0,
                                        }}
                                    >
                                        <div style={{ flex: 1 }}>
                                            <EtcDataGrid
                                                data={paymentHistoryData}
                                                columns={paymentHistoryColumns}
                                                pageSize={30}
                                                selectionModel={selectedIds}
                                                onSelectionModelChange={handleSelectionChange}
                                            />
                                        </div>
                                        <div style={{ padding: "10px", textAlign: "left" }}>
                                            <Button
                                                variant="primary"
                                                onClick={handleOpenManualPaymentUpdateDialog}
                                            >
                                                Manuel Ödeme Güncelle
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Row>
                    </Tab>
                </Tabs> : <div style={{position: "flex"}}>

                    {hasAdminManagement &&
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 4}}>
                            <div style={{display: 'flex'}}>
                                <FormControl type='text'
                                             placeholder="Tutar"
                                             size="sm"
                                             style={{width: 100}}
                                             value={payAmount}
                                             onChange={onChangePayAmount}
                                             disabled={!ONLINE_PAYMENT_ENABLED}
                                />
                                <Button
                                    variant={!ONLINE_PAYMENT_ENABLED ? "secondary" : "warning"}
                                    size="sm"
                                    style={{
                                        width: 150,
                                        ...(!ONLINE_PAYMENT_ENABLED ? disabledPaymentButtonStyle : {})
                                    }}
                                    disabled={!ONLINE_PAYMENT_ENABLED}
                                    onClick={ONLINE_PAYMENT_ENABLED ? openPayModal : undefined}>
                                    Test Ödeme Yap
                                </Button>
                            </div>
                            <OnlinePaymentDisabledNotice style={{marginTop: 4}}/>
                        </div>}

                    {
                        tenantDataShow === null ? chooseTenant() :
                            <Spinner style={{position: "flex", textAlign: "center", color: "grey"}} size="lg"
                                     animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner>
                    }

                </div>}
                <PaymentModal payAmount={payAmount} type={"Test"}
                              showModal={showPayModal}
                              request={{"subscriptionBillingTypeEnumValue": "TEST_PAYMENT"}}
                              close={closeShowPayModal}
                              cookies={cookies}/>

                <ManualPaymentUpdateDialog
                    openDialog={isManualPaymentUpdateDialogOpen}
                    getHistoryData={getHistoryData}
                    selectedTenant={selectedTenant}
                    // paymentHistoryData={paymentHistoryData}
                    currentAmount={selectedPaymentAmount}
                    paymentModal={selectedIds}
                    handleCloseDialog={() => setIsManualPaymentUpdateDialogOpen(false)}
                />

                {loginShow ? <Login setCookie={setCookie}/> : null}
            </div>
        );
    } else if (showDiscountManagerPanel) {
        return (<DiscountManagerPanel setCookie={setCookie} removeCookie={removeCookie}
                                      adminManagement={hasAdminManagement}/>)
    } else {
        return (
            <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
                <Spinner size="lg" animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
        );
    }
}

export default SubscriptionAdminPanel;
